<template lang="pug">
  div.balance
    div.toolbar
      .mobile-title
        span.mobile-title__number.semibold 03
        span Целевые показатели по обезвреживанию, утилизации и размещению отходов
      div.top-header
        h1.title {{$route.meta ? $route.meta.title : '' }}
        div.actions-panel.view-panel.view-panel_divide
          e-button-add(
            v-if="hasDownloadFileButton && getFileNameDownload($route.name)"
            @click="handleDownload($route.name)"
            label="Скачать приложения к ТС"
            btnDefaultClass=" "
          ).actions-panel__button.btn-text.button.button_usual
          div.actions-panel.view-panel.view-panel_divide
            button.actions-panel__button.btn-export.view-panel__button.button_export.button_icon(
              v-if="hasItems"
              :title="$translate('Экспорт')"
              @click="redirectToExport()"
            )
            e-button-add.view-panel__button.view-panel__button_add(
              @click="handleAdd"
              title="Добавить целевой показатель"
              label="Добавить"
            )
            e-year-selector(year="year" @onSelectItem='onSelectYear')
    .content.overflow-visible.max-height-initial
      div.wrapper
        .table.table_balance
          .table__header
            .table__row
              .table__col.table__head Класс опасности
              .table__col.table__head Наличие отходов на начало отчетного года
              .table__col.table__head Образование отходов за отчетный год
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 3)")
                span Поступление отходов из других хозяйствующих субъектов
                .display-flex(style="min-width:calc(130px * 3)")
                  .table__col.table__head всего
                  .table__col.table__head из других субъектов РФ
                  .table__col.table__head по импорту из других государств
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                span Поступление отходов с собственных объектов
                .display-flex(style="min-width:calc(130px * 2)")
                  .table__col.table__head всего
                  .table__col.table__head из других субъектов РФ
              .table__col.table__head Образование после обработки других видов отходов за отчетный год
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                span Обработано отходов
                .display-flex(style="min-width:calc(130px * 2)")
                  .table__col.table__head всего
                  .table__col.table__head отношение к образованным отходам, %
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 4)")
                span Утилизировано отходов
                .display-flex(style="min-width:calc(130px * 4)")
                  .table__col.table__head всего
                  .table__col.table__head
                    span отношение к образованным отходам, %
                  .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                    span из них
                    .display-flex(style="min-width:calc(130px * 2)")
                      .table__col.table__head для повторного (рециклинг)
                      .table__col.table__head предварительно прошедших обработку
              .table__col.table__head Обезврежено отходов
              .table__col.table__head Передача ТКО региональному оператору
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 10)")
                span Передача отходов (за исключением ТКО) другим хозяйствующим субъектам
                .display-flex
                  .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                    span для обработки
                    .display-flex
                      .table__col.table__head всего
                      .table__col.table__head  из них в другие субъекты РФ
                  .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                    span для утилизации
                    .display-flex
                      .table__col.table__head всего
                      .table__col.table__head  из них в другие субъекты РФ
                  .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                    span для обезвреживания
                    .display-flex
                      .table__col.table__head всего
                      .table__col.table__head  из них в другие субъекты РФ
                  .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                    span для хранения
                    .display-flex
                      .table__col.table__head всего
                      .table__col.table__head  из них в другие субъекты РФ
                  .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                    span для захоронения
                    .display-flex
                      .table__col.table__head всего
                      .table__col.table__head  из них в другие субъекты РФ
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 2)")
                span Передача отходов (кроме ТКО) на собственные объекты
                .display-flex
                  .table__col.table__head всего
                  .table__col.table__head  из них в другие субъекты РФ
              .table__col.table__head.table__head_with-children(style="min-width:calc(130px * 3)")
                span Размещение отходов на эксплуатируемых объектах
                .display-flex
                  .table__col.table__head хранение
                  .table__col.table__head  захоронение
                  .table__col.table__head  отношение к образованным отходам, %
              .table__col.table__head Наличие отходов на конец отчетного года
              .table__col.table__head.edit-head
          .table__body
            .table__row(v-for="(block, i) in items" :key="'block-'+i")
              .block-header
                .block-name {{block.fkko.code}} {{block.fkko.name}}
                .table__row(v-for="item in block.items")
                  .table__col(v-for="key in fields")
                    span(
                      :contenteditable="key !== 'danger' ? item.contenteditable : false"
                      v-model="item[key]"
                      :data-key="key"
                      @paste="(e) => item[key] = updateCopyValue(e)"
                      @blur="(e) => handleBlur(e, item, key)"
                      @change="(e) => handleChange(e, item, key)"
                    ) {{itemText(key, item[key])}}
                  .table__col.table__col_sticky
                    button.reset-btn.button.button_edit.button_small.button_icon(
                      @click.prevent="editRow(item)"
                      title="Редактировать"
                    )
                .table__row
                  .table__col(v-for="key in fields") {{itemText(key, block.total[key], true)}}
                  .table__col.table__col_sticky
                    .display-flex
                      button.button.button_delete.reset-btn.button_icon(
                        @click.prevent="deleteRow(block)"
                        title="Удалить"
                      )
                      button.button.button_save.reset-btn.button_icon(
                        @click.prevent="saveHandle(block)"
                        title="Сохранить"
                      )
            .table__row(v-if="hasAllBlock")
              .block-header
                .block-name Всего отходов
                .table__row(v-for="(item, i) in total.items" :key="'total-'+i")
                  .table__col.total-item.semibold(v-for="key in fields") {{itemText(key, item[key])}}
                  .table__col.total-item.last
                .table__row(v-if="total.total" )
                  .table__col.total-item.semibold(v-for="key in fields") {{itemText(key, total.total[key], true)}}
                  .table__col.total-item.last
    e-modal(
      v-if="showAddModal"
      modalClass="fixed-overlay fixed-overlay__modal autoHeight"
      @close="showAddModal = false"
      @confirm="saveItem"
      title="Добавление"
    )
      slot
        .add-popup
          .add-field
            label.add-field__label(for="add-field-input") Наименование*
            input.add-field__input#add-field-input(
              v-model="newItem.name"
              placeholder="Введите минимум 2 символа"
              v-debounce:300="changeNewItem"
            )
          .add-popup__error(v-if="hasFkkoError") Фкко не найдено
          ul.add-list
            li.add-list__item(
              v-for="item in addList"
              @click="selectItem(item)"
            ) {{item.name}}
</template>

<script>
import { cadastr, indicator } from '@/api/api-endpoints'
import year from '@/utils/year'
import exportMixin from '@/mixins/export-mixin'
import routeMixin from '@/mixins/route-mixin'
import { REGION_CONFIG } from '@/config/regions'
import downloadFileMixin from '@/mixins/download-file-mixin'
import hasMixin from '@/mixins/has-mixin'

const PER_PAGE = 10
const COUNT_CLASSES = 5

export default {
  name: 'balance',
  mixins: [exportMixin, routeMixin, downloadFileMixin, hasMixin],
  data() {
    return {
      query: '',
      header: [],
      rawItems: [],
      total: { items: [] },
      newItem: {
        id: null,
        name: '',
      },
      hasFkkoError: false,
      addList: [],
      showAddModal: false,
      hasItems: false,
      year:
        this.$route?.query?.year || REGION_CONFIG.customBalanceYear
          ? REGION_CONFIG.customBalanceYear
          : year.getCurrentYear(),
    }
  },
  computed: {
    fields() {
      const fields = []

      function countFields(obj) {
        obj.forEach((item) => {
          if (item.path) {
            fields.push(item.path)
          }
          if (item['childs'] && item['childs'].length) {
            countFields(item.childs)
          }
        })
      }

      countFields(this.header)
      return fields
    },
    items() {
      return this.rawItems.map((item) => {
        const newItems = item.items.map((el) => {
          return this.addEditableAttr(el)
        })
        return {
          ...item,
          items: newItems,
        }
      })
    },
    rowData() {
      const obj = {}

      this.fields.map((item) => {
        obj[item] = 0
      })
      return obj
    },
    hasAllBlock() {
      if (!this.total.items.length) return false
      return this.total.items.every((item) => {
        return Object.values(item).length
      })
    },
    endpointExport() {
      const currentYear = this.year
      return indicator.fkkoExport({ query: { year: currentYear } })
    },
  },
  methods: {
    handleAdd() {
      this.showAddModal = true
    },
    saveItem() {
      if (!this.newItem.id) {
        this.hasFkkoError = true
        return false
      }

      const items = []
      for (let i = 1; i <= COUNT_CLASSES; i++) {
        const item = { ...this.rowData, danger: i, fkko_id: this.newItem.id }
        items.push(item)
      }
      const total = this.rowData
      const fkko = {
        id: this.newItem.id,
        name: this.newItem.name,
      }
      this.rawItems.push({
        fkko,
        items,
        total,
      })
      this.newItem.name = ''
      this.newItem.id = null
      this.showAddModal = false
    },
    editRow(item) {
      item.contenteditable = !item.contenteditable
      this.$forceUpdate()
    },
    deleteRow(block) {
      const fkko_id = block.fkko.id

      this.$e.confirmBox().then(async () => {
        await this.$store.dispatch('deleteModel', {
          url: indicator.fkko({
            query: { year: this.year, fkko_id },
          }),
          data: {},
        })

        this.$e.successBox('Запись удалена')
        this.getData()
      })
    },
    async saveHandle(block) {
      block.items.map((el) => {
        delete el.contenteditable
        return el
      })
      try {
        await this.$store.dispatch('createModel', {
          url: indicator.fkko(),
          data: {
            year: this.year,
            items: block.items,
          },
        })
        this.hasItems = true
        this.$e.successBox('Запись сохранена')
        this.getData()
      } catch (e) {
        const errors = Object.values(e.data.errors).join(', ')
        this.$e.errorBox(errors)
      }
    },
    async getData() {
      this.year = this.$route?.query?.year || this.year
      const data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: indicator.fkko({ query: { year: this.year } }),
        })
      ).data

      this.rawItems = data.data.items
      this.total = data.data.total
      this.header = data._meta.fields
      this.hasItems = !!this.rawItems.length
    },
    async changeNewItem(val) {
      this.hasFkkoError = false
      if (val.length < 2) {
        this.addList = []
        return false
      }
      this.addList = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: cadastr.fkko({
            query: {
              q: val,
              'per-page': PER_PAGE,
              sort: 'code',
              has_danger_only: 0,
            },
          }),
        })
      ).data.data
    },
    addEditableAttr(item) {
      return {
        ...item,
        contenteditable: false,
      }
    },
    itemText(key, text, isTotal = false) {
      if (key === 'danger') {
        if (!text) {
          text = 0
        }
        text = text + ' класс'
        if (isTotal) {
          text = 'Всего'
        }
      }
      return text
    },
    selectItem(item) {
      this.newItem = {
        id: item.id,
        name: item.name,
      }
      this.addList = []
    },
    updateCopyValue(e) {
      const value = e.clipboardData.getData('text/plain')
      const newValue = value.replace(/,/g, '.')
      e.currentTarget.blur()
      e.currentTarget.textContent = newValue
      return newValue
    },
    handleBlur(e, item, key) {
      const value = e.currentTarget.textContent
      item[key] = value.replace(/,/g, '.')
      this.$forceUpdate()
    },
    handleChange(e, item, key) {
      const value = e.currentTarget.textContent
      const newValue = value.replace(/,/g, '.')
      e.currentTarget.textContent = newValue
      item[key] = newValue
    },
    onSelectYear(year) {
      this.replaceRoute({
        year: year,
      })
      this.getData()
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/utils/variables';
@import '../../assets/scss/utils/mixins';

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block {
  margin-top: -20px;
}

.block-name {
  padding: 15px;
  background-color: #dae3f3;
  border-color: #dae3f3;
}

.main-layout {
  .content {
    .table {
      overflow-y: auto;
      max-height: calc(100vh - 166px);

      &::-webkit-scrollbar {
        height: 6px;
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        box-shadow: inset 0 0 6px rgba(170, 170, 170, 0.6);
      }

      th,
      td {
        min-width: 135px;
        max-width: 135px;
        border: 1px solid #ddd;
        border-top: none;
        border-left: none;

        &:first-child {
          border-width: 1px;
        }
      }

      td {
        &.block-header {
          padding-left: 0 !important;
        }

        &.total-item {
          font-weight: 700;

          &.last {
            min-width: 97px;
          }
        }

        [contenteditable='true'] {
          display: inline-block;
          min-width: 50px;
          padding: 5px;
          background-color: #e2e2e2;
        }

        &.block-name {
          background-color: #dae3f3;
          border-color: #dae3f3;
          text-align: center;
        }

        &:first-child {
          border-left-width: 0;

          &.block-name {
            border-color: #dae3f3;
          }
        }
      }

      table {
        border-collapse: initial;

        thead {
          position: sticky !important;
          top: 0;
          z-index: 2;
          background-color: #fff;

          th {
            text-align: center;

            &.edit-head {
              min-width: 97px;
              border-bottom: none;
              border-right: none;
            }
          }
        }

        tbody {
          transform: translateX(-2px);

          tr {
            &:last-child {
              td {
                border-bottom: none;
              }
            }

            td {
              &.block-header {
                padding: 0;
              }

              &.edit-col {
                position: sticky !important;
                right: 0;
                min-width: 97px;
                border: none;
                padding: 5px;
                background: #fff;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    position: sticky;
    bottom: 0;
    left: 0;
    background-color: #fff;
  }

  .footer-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .add-popup {
    padding: 20px;
    min-height: 200px;

    &__error {
      color: $error-color;
      margin-top: 10px;
    }
  }

  .add-field {
    &__label {
      display: inline-block;
      margin-bottom: 10px;
    }

    &__input {
      width: 100%;
    }
  }

  .add-list {
    position: relative;
    list-style-type: none;
    background-color: #fff;
    z-index: 2;
    margin: 0;
    padding: 0;
    max-height: 400px;
    max-width: 400px;
    overflow: hidden;
    overflow-y: scroll;
    @include scrollbars();

    &__item {
      padding: 10px;
      border: 1px solid #e2e2e2;
      cursor: pointer;

      &:first-child {
        border-top: none;
      }

      &:not(:last-child) {
        border-bottom: none;
      }
    }
  }
}

.button_green {
  margin-right: 10px;
}

@media screen and (max-width: $mobile-width) {
  .top-header {
    display: block;
  }
}
</style>
